'use client'

import { m } from 'framer-motion'

const items = [
  {
    id: '01',
    title: 'Разработка',
    desc: 'Сайты, приложения, веб-сервисы, интеграции',
    tag: 'Технологии',
  },
  {
    id: '02',
    title: 'AI-автоматизация',
    desc: 'Чат-боты, голосовые ассистенты, базы знаний, автоворонки',
    tag: 'AI',
  },
  { id: '03', title: 'Дизайн', desc: 'UI/UX, веб-дизайн, брендинг, презентации', tag: 'Креатив' },
  {
    id: '04',
    title: 'Маркетинг',
    desc: 'Контекстная реклама, SEO, аналитика, воронки продаж',
    tag: 'Рост',
  },
  {
    id: '05',
    title: 'SMM',
    desc: 'Стратегия, контент, таргет, комьюнити-менеджмент',
    tag: 'Соцсети',
  },
]

export default function AgencyAwards() {
  return (
    <section className="py-16 sm:py-24">
      <div className="home-container">
        <div className="mb-12 flex flex-col items-start gap-8 sm:mb-16 sm:gap-12 lg:flex-row lg:gap-24">
          <div className="lg:w-1/3">
            <h2 className="home-title mb-5 sm:mb-6">Ключевые компетенции</h2>
            <p className="home-subnote text-gray-400">
              Наш опыт и экспертиза позволяют решать задачи любой сложности.
            </p>
          </div>
        </div>

        <div className="space-y-0">
          {items.map((item, i) => (
            <m.div
              key={item.id}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="group flex flex-col justify-between gap-6 border-b border-white/10 py-7 transition-colors hover:border-white/30 sm:flex-row sm:items-center sm:gap-10 sm:py-8"
            >
              <div className="flex min-w-0 items-baseline gap-4 sm:gap-6">
                <span className="home-meta shrink-0 text-gray-500">{item.id}</span>
                <h3 className="home-card-title min-w-0 transition-colors group-hover:text-blue-400">
                  {item.title}
                </h3>
              </div>

              <div className="flex min-w-0 flex-col gap-3 text-gray-400 sm:flex-row sm:items-center sm:gap-8">
                <span className="home-subnote max-w-[58ch] leading-relaxed text-gray-300/70 sm:text-gray-400">
                  {item.desc}
                </span>
                <span className="home-meta w-fit rounded-full border border-white/10 px-3 py-1 text-gray-500">
                  {item.tag}
                </span>
              </div>
            </m.div>
          ))}
        </div>
      </div>
    </section>
  )
}
